import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MembershipService } from 'app/core/services/membership.service';
import { SessionIdleService } from 'app/services/session-idle.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  standalone: false,
  selector: 'session-timeout',
  templateUrl: './session-timeout.component.html'
})
export class SessionTimeoutComponent implements OnInit,OnDestroy {
  countdown = 60;
  showModal = false;
  private destroy$ = new Subject<void>();

  constructor(private router:Router,private session_idle_service: SessionIdleService,private membership_service: MembershipService) {}




  ngOnInit(): void {

    this.session_idle_service.session_warning$
     .pipe(takeUntil(this.destroy$))
     .subscribe((show: boolean) => {
        this.showModal = show;
    });
    this.session_idle_service.count_down$
     .pipe(takeUntil(this.destroy$))
    .subscribe((count: number) => {
        this.countdown = count;
    });
  }

  ngOnDestroy(): void {
    this.destroy$?.next();
    this.destroy$?.complete();
  }
  stayLoggedIn() {

    this.session_idle_service.extend_session();
  }


}
